import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    NotificationsComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    NotificationsRoutingModule
  ],

})
export class NotificationsModule { }
